module.exports = __webpack_public_path__ + "static/img/bg-pt.369dae54.png";